import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
import { Input, Switch } from 'antd'
import { useAppSelector, useAppDispatch } from 'store/hooks'
import { slices } from 'store/slices'
import {
  Wrapper,
  Title,
  Content,
  Option,
  MandatoryExtras,
  NestedSetting,
  InfoAlert,
} from './styled'

const EvaluationBehavior = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const translationPrefix =
    'administration.blocks.type.questionBankV2.evaluationBehavior'
  const data = useAppSelector(slices.questionBank.data)

  return (
    <Wrapper>
      <Title>{t(`${translationPrefix}.title`)}</Title>
      <Content>
        <Option>
          <div>
            <div>
              <span>
                {t(`${translationPrefix}.options.mandatoryEvaluation.title`)}
              </span>
              <div>
                {t(
                  `${translationPrefix}.options.mandatoryEvaluation.mustCompleteToContinue`
                )}
              </div>
            </div>
            <Switch
              checked={data.mandatory}
              onChange={(checked) =>
                dispatch(slices.questionBank.setMandatoryEvaluation(checked))
              }
            />
          </div>
          {data.mandatory && (
            <MandatoryExtras>
              <NestedSetting>
                <div>
                  <div>
                    <span>
                      {t(`${translationPrefix}.options.approvalRequired.title`)}
                    </span>
                    <div>
                      {t(
                        `${translationPrefix}.options.approvalRequired.description`
                      )}
                    </div>
                  </div>
                  <Switch
                    checked={data.approvalRequired}
                    onChange={(checked) =>
                      dispatch(slices.questionBank.setApprovalRequired(checked))
                    }
                  />
                </div>
              </NestedSetting>
              {!data.approvalRequired && (
                <InfoAlert>
                  <FontAwesomeIcon icon={faInfoCircle} />
                  <div>
                    {t(`${translationPrefix}.options.approvalRequired.alert`)}
                  </div>
                </InfoAlert>
              )}
            </MandatoryExtras>
          )}
        </Option>
        <Option>
          <div>
            <div>
              <span>
                {t(`${translationPrefix}.options.allowReviewOfResults.title`)}
              </span>
              <div>
                {t(
                  `${translationPrefix}.options.allowReviewOfResults.description`
                )}
              </div>
            </div>
            <Switch
              checked={data.showResults}
              onChange={(checked) =>
                dispatch(slices.questionBank.setAllowReviewOfResults(checked))
              }
            />
          </div>
        </Option>
        <Option>
          <div>
            <div>
              <span>
                {t(`${translationPrefix}.options.enableAttemptLimit.title`)}
              </span>
              <div>
                {t(
                  `${translationPrefix}.options.enableAttemptLimit.description`
                )}
              </div>
            </div>
            <Switch
              checked={data.multipleRetries}
              onChange={(checked) =>
                dispatch(slices.questionBank.setEnableAttemptLimit(checked))
              }
            />
          </div>
          {data.multipleRetries && (
            <div data-evaluation-behavior="retry-panel">
              <div>
                {t(
                  `${translationPrefix}.options.enableAttemptLimit.maximumEvaluationAttempts.title`
                )}
              </div>
              <div>
                <Input
                  type="number"
                  min={1}
                  value={data.maxRetries}
                  onChange={(e) => {
                    const value = e.target.value
                    dispatch(
                      slices.questionBank.setMaximumEvaluationAttempts(
                        value === '' ? '' : Number(value)
                      )
                    )
                  }}
                />
                <span>
                  {t(
                    `${translationPrefix}.options.enableAttemptLimit.maximumEvaluationAttempts.${
                      +data.maxRetries > 1 ? 'attempts' : 'attempt'
                    }`
                  )}
                </span>
              </div>
            </div>
          )}
        </Option>
      </Content>
    </Wrapper>
  )
}

export default EvaluationBehavior
